module.exports = __webpack_public_path__ + "static/media/InsuranceApplications.f4f471d4.jpg";